import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/anthem-logo.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-fund-hw" }, null, -1)
const _hoisted_2 = { class: "col-md-9" }
const _hoisted_3 = { class: "fund-cover fund-cover__hw" }
const _hoisted_4 = { class: "fund-cover-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", null, "Current Coverage", -1)
const _hoisted_6 = {
  key: 0,
  class: "fund-coverages"
}
const _hoisted_7 = { class: "coverage-row" }
const _hoisted_8 = { class: "coverage-column" }
const _hoisted_9 = { class: "plan-modal no-link" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "coverage-column-items" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "coverage-column" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-calendar" }),
    /*#__PURE__*/_createElementVNode("p", { class: "links" }, "Coverage Period: TBD ")
  ])
], -1)
const _hoisted_11 = {
  key: 0,
  class: "coverage-column__actions d-flex align-items-center"
}
const _hoisted_12 = { class: "pdl-30" }
const _hoisted_13 = {
  key: 1,
  class: "fund-coverages"
}
const _hoisted_14 = { class: "coverage-row" }
const _hoisted_15 = { class: "coverage-column" }
const _hoisted_16 = { class: "plan-modal" }
const _hoisted_17 = {
  key: 0,
  class: "coverage-column__actions d-flex align-items-center"
}
const _hoisted_18 = { class: "pdl-30" }
const _hoisted_19 = {
  key: 2,
  class: "fund-coverages"
}
const _hoisted_20 = { class: "coverage-row" }
const _hoisted_21 = { class: "coverage-column pdr-15" }
const _hoisted_22 = { class: "plan-modal no-link" }
const _hoisted_23 = {
  key: 0,
  class: "coverage-column__actions d-flex align-items-center"
}
const _hoisted_24 = {
  key: 0,
  class: "pdl-30"
}
const _hoisted_25 = {
  key: 3,
  class: "fund-coverages"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "coverage-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "coverage-column-items" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "coverage-column" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-calendar" }),
      /*#__PURE__*/_createElementVNode("p", { class: "links" }, "Coverage Period: TBD ")
    ])
  ])
], -1)
const _hoisted_27 = { class: "coverage-column__actions" }
const _hoisted_28 = {
  key: 0,
  class: "pdl-30"
}
const _hoisted_29 = {
  key: 4,
  class: "fund-coverages"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "coverage-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "coverage-column" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "plan-modal" }, "Not Currently Enrolled")
  ])
], -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "fund-cover-buttons sm-pdt-20 mt-20" }
const _hoisted_33 = { class: "sso sso-anthem mt-15" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Anthem Logo",
  title: "anthem-logo"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FundPanel = _resolveComponent("FundPanel")!

  return (_openBlock(), _createBlock(_component_FundPanel, {
    cardId: "card-hw",
    alerts: _ctx.alerts
  }, {
    icon: _withCtx(() => [
      _hoisted_1
    ]),
    title: _withCtx(() => [
      _createTextVNode(" Health & Welfare ")
    ]),
    "fund-cover": _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            (_ctx.showNextCoverageLink)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitUpcomingCoverage && _ctx.emitUpcomingCoverage(...args)), ["prevent"])),
                  class: "btn btn-secondary plan-modal upcoming-coverage"
                }, "Upcoming Coverage"))
              : _createCommentVNode("", true)
          ]),
          (_ctx.hasPlanCCurrentInvoice)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.data.PlanCInvoices?.Current?.Paid ?
                                        'Your cov. selection of ' + _ctx.data.PlanCInvoices?.Current?.SelectedPlanCOption + ' for ' 
                                        + _ctx.data.PlanCInvoices?.Current?.CappCoveragePeriod  + ' - ' + _ctx.data.PlanCInvoices?.Current?.CappCoveragePeriodEnd
                                        + ' is in process'
                                        : 'Not Currently Enrolled'), 1)
                  ]),
                  _hoisted_10
                ]),
                (!_ctx.data.PlanCInvoices.Current.Paid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (!_ctx.data.PlanCInvoices?.Current?.Paid && !_ctx.data.HasPendingMrpDocs)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "#",
                            class: "btn btn-primary plan-modal",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openModal('hw-capp-statement', 'Make Coverage Selection / Co-Payment', 'plan-upload plan-card-info plan-c-mrp-claims')), ["prevent"]))
                          }, " Select/Pay Plan C Cov "))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", _hoisted_12, "Plan C Due Date: " + _toDisplayString(_ctx.data.PlanCInvoices?.Current?.DueDate), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.hasPlanCobraCurrentInvoice)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.data.CobraInvoices?.Current?.IsPaid ?
                                        'Your COBRA Payment for ' + _ctx.data.CobraInvoices?.Current?.InsuranceStartDate + ' to ' + _ctx.data.CobraInvoices?.Current?.InsuranceEndDate + ' will be processed soon':
                                         'Not Currently Enrolled'), 1)
                  ])
                ]),
                (!_ctx.data.CobraInvoices?.Current?.IsPaid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("a", {
                        href: "#",
                        class: "btn btn-primary plan-modal",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.openModal('hw-cobra-statements', 'Make COBRA Payment', 'plan-upload plan-card-info plan-c-mrp-claims')), ["prevent"]))
                      }, " Make COBRA Payment "),
                      _createElementVNode("p", _hoisted_18, "COBRA Due Date: " + _toDisplayString(_ctx.data.CobraInvoices?.Current?.DueDate), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.hasPlanCUpcomingInvoice)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("h3", _hoisted_22, _toDisplayString(_ctx.data.PlanCInvoices?.Upcoming?.Paid && _ctx.data.NextCoverage.PlanClass == null ?
                                         'Your cov. selection of ' + _ctx.data.PlanCInvoices?.Upcoming?.SelectedPlanCOption + ' for ' 
                                         + _ctx.data.PlanCInvoices?.Upcoming?.CappCoveragePeriod + ' - ' + _ctx.data.PlanCInvoices?.Upcoming?.CappCoveragePeriodEnd
                                         + ' is in progress.'
                                        : 'Not Currently Enrolled'), 1)
                  ])
                ]),
                (!_ctx.data.PlanCInvoices?.Upcoming?.Paid && !_ctx.data.HasPendingMrpDocs)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("a", {
                        href: "#",
                        class: "btn btn-primary plan-modal",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openModal('hw-capp-statement', 'Make Coverage Selection / Co-Payment', 'plan-upload plan-card-info plan-c-mrp-claims')), ["prevent"]))
                      }, " Select/Pay Plan C Cov "),
                      (!_ctx.data.PlanCInvoices?.Upcoming?.Paid)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_24, "Plan C Due Date: " + _toDisplayString(_ctx.data.PlanCInvoices?.Upcoming?.DueDate), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.hasPlanCobraUpcomingInvoice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "btn btn-primary plan-modal",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.openModal('hw-cobra-statements', 'Make COBRA Payment', 'plan-upload plan-card-info plan-c-mrp-claims')), ["prevent"]))
                    }, " Make COBRA Payment "),
                    (!_ctx.data.CobraInvoices?.Upcoming?.Paid)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_28, "COBRA Due Date: " + _toDisplayString(_ctx.data.CobraInvoices?.Upcoming?.DueDate), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
          (!_ctx.hasPlanCCurrentInvoice && !_ctx.hasPlanCobraCurrentInvoice && !_ctx.hasPlanCUpcomingInvoice && !_ctx.hasPlanCobraUpcomingInvoice)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_32, [
            (_ctx.data?.HasRetireePaymentsHistory)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "btn btn-secondary plan-modal inline-block",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.openModal('hw-retiree-payments-history', 'Payments History', 'plan-retiree')), ["prevent"]))
                }, "Retiree Payments History"))
              : _createCommentVNode("", true),
            _createElementVNode("a", {
              href: "",
              class: "btn btn-primary plan-modal",
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.openModal('work-history', 'Health & Welfare Work History', null, 'health', null, null, undefined, { Funds: [3, 4]})), ["prevent"]))
            }, "Work History ")
          ]),
          _createElementVNode("div", _hoisted_33, [
            (_ctx.IsAnthemSsoEnabled)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-secondary btn-sso",
                  onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.$anthemSsoLogin && _ctx.$anthemSsoLogin(...args)), ["prevent"]))
                }, [
                  _hoisted_34,
                  _createTextVNode(" Login ")
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    "related-links": _withCtx(() => [
      (_ctx.data.IsAvailableForClaim)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: "",
            class: "btn btn-tertiary btn-large plan-modal",
            onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.openModal('claims', 'Claims', 'plan-upload plan-card-info plan-c-mrp-claims')), ["prevent"]))
          }, "View/Submit Claims"))
        : _createCommentVNode("", true),
      _createElementVNode("a", {
        href: "",
        class: "btn btn-tertiary btn-large plan-modal",
        onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.openModal('dependents', 'My Dependents', null)), ["prevent"]))
      }, " Dependents "),
      _createElementVNode("a", {
        href: "",
        onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.openModal('plan-resources', 'Health & Welfare Resources', null, 'Health and Welfare')), ["prevent"])),
        class: "btn btn-tertiary btn-large plan-modal"
      }, "Fund's Resources")
    ]),
    _: 1
  }, 8, ["alerts"]))
}